import React from 'react';

/**
 * MedRahi Logo - Indian Mandala with M & R
 * A beautiful mandala-inspired logo representing healthcare and healing
 */
export default function Logo({ size = 'md', className = '' }) {
  const sizes = {
    sm: { container: 'w-8 h-8', svg: 32 },
    md: { container: 'w-12 h-12', svg: 48 },
    lg: { container: 'w-16 h-16', svg: 64 },
    xl: { container: 'w-20 h-20', svg: 80 },
  };

  const { container, svg } = sizes[size] || sizes.md;

  return (
    <div className={`${container} bg-gradient-to-br from-orange-500 to-red-600 rounded-lg flex items-center justify-center shadow-lg ${className}`}>
      <svg 
        width={svg * 0.75} 
        height={svg * 0.75} 
        viewBox="0 0 100 100" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Outer Mandala Ring */}
        <circle cx="50" cy="50" r="46" stroke="white" strokeWidth="1.5" strokeOpacity="0.3" fill="none" />
        
        {/* Mandala Petals - Outer */}
        {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, i) => (
          <ellipse
            key={`outer-${i}`}
            cx="50"
            cy="12"
            rx="6"
            ry="10"
            fill="white"
            fillOpacity="0.2"
            transform={`rotate(${angle} 50 50)`}
          />
        ))}
        
        {/* Inner Mandala Ring */}
        <circle cx="50" cy="50" r="32" stroke="white" strokeWidth="1" strokeOpacity="0.4" fill="none" />
        
        {/* Mandala Petals - Inner */}
        {[22.5, 67.5, 112.5, 157.5, 202.5, 247.5, 292.5, 337.5].map((angle, i) => (
          <ellipse
            key={`inner-${i}`}
            cx="50"
            cy="22"
            rx="4"
            ry="8"
            fill="white"
            fillOpacity="0.25"
            transform={`rotate(${angle} 50 50)`}
          />
        ))}
        
        {/* Center Circle with Gradient Feel */}
        <circle cx="50" cy="50" r="24" fill="white" fillOpacity="0.15" />
        <circle cx="50" cy="50" r="20" fill="white" fillOpacity="0.1" />
        
        {/* M Letter */}
        <path
          d="M32 62V40L40 54L48 40V62"
          stroke="white"
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        
        {/* R Letter */}
        <path
          d="M54 62V40H64C68 40 71 43 71 47C71 51 68 54 64 54H54M54 54L68 62"
          stroke="white"
          strokeWidth="3.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        
        {/* Small decorative dots around center */}
        {[0, 60, 120, 180, 240, 300].map((angle, i) => (
          <circle
            key={`dot-${i}`}
            cx={50 + 28 * Math.cos((angle * Math.PI) / 180)}
            cy={50 + 28 * Math.sin((angle * Math.PI) / 180)}
            r="2"
            fill="white"
            fillOpacity="0.5"
          />
        ))}
        
        {/* Corner accent dots */}
        {[45, 135, 225, 315].map((angle, i) => (
          <circle
            key={`corner-${i}`}
            cx={50 + 40 * Math.cos((angle * Math.PI) / 180)}
            cy={50 + 40 * Math.sin((angle * Math.PI) / 180)}
            r="1.5"
            fill="white"
            fillOpacity="0.4"
          />
        ))}
      </svg>
    </div>
  );
}

// Alternative simpler version for smaller sizes
export function LogoSimple({ size = 'md', className = '' }) {
  const sizes = {
    sm: { container: 'w-8 h-8', text: 'text-xs' },
    md: { container: 'w-10 h-10', text: 'text-sm' },
    lg: { container: 'w-12 h-12', text: 'text-base' },
  };

  const { container, text } = sizes[size] || sizes.md;

  return (
    <div className={`${container} bg-gradient-to-br from-orange-500 to-red-600 rounded-lg flex items-center justify-center shadow-lg ${className}`}>
      <span className={`${text} font-bold text-white tracking-tight`}>MR</span>
    </div>
  );
}
